:global(.btn).toolButton {
  background-color: var(--bs-light-border-subtle);
  border: 1px solid var(--bs-border-color);
  white-space: nowrap;
}

.marginRight {
  margin-right: 0.5em;
}

.toolButton:focus {
  outline: none;
  box-shadow:
    0 0 0 2px rgba(var(--bs-primary-rgb), 0.5),
    inset 0 2px 4px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

:global(.btn).toolButton.subtle {
  background-color: var(--bs-light);
}

:global(.btn).toolButton.latched,
:global(.btn).toolButton.latched:hover {
  background-color: var(--bs-secondary-bg);
  box-shadow:
    inset 0 2px 4px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.collapsibleLabel {
  margin-left: 0.5em;
}

/* Below this width the label is visually hidden but stays the accessible name. */
@media (max-width: 1300px) {
  .collapsibleLabel {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }
}
